'use strict'

export default (mockAxios) => {
  // 名刺人物一覧情報を取得
  mockAxios.onPost(`/persons`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'new_id': 1,
        'openflag': '1',
        'corporate_name': '株式会社RRRコンピューターサービス',
        'dept': '公共情報事業本部',
        'post': '主任心得',
        'bcards': [
          {
            'id': 1,
            'last_kana': 'オオモリ',
            'first_kana': 'ケイスケ',
            'corporate_name': '株式会社RRRコンピューターサービス',
            'corporate_kana': 'あーるあーるあーる',
            'dept': '公共情報事業本部',
            'post': '主任心得',
            'full_name': '大森 圭介',
            'formatted_exdate': '2018/01/01'
          }
        ],
        'full_name': '大森 圭介',
        'formatted_exdate': '2018/01/01'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  // 名刺詳細情報を取得します。
  mockAxios.onGet(new RegExp(`/persons/overview`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'sid_person': 1,
      'corporate_name': '株式会社RRRコンピューターサービス',
      'corporate_kana': 'あーるあーるあーる',
      'company_name': 'RRRカンパニー',
      'company_kana': 'あーるあーるあーるかんぱにー',
      'dept': '公共情報事業本部',
      'post': '主任心得',
      'dept_post': '技術課＋部長',
      'o1_office_name': '横浜事業所',
      'o1_zipcode': '100-2525',
      'o1_address1': '東京都品川区西大井1-1-2',
      'o1_address2': '八木ビル5F',
      'o1_tel1': '0330-88-1590',
      'o1_naisen1': '00331',
      'o1_tel2': '0330-88-1595',
      'o1_naisen2': '00331',
      'o1_mobile': '080-1212-3434',
      'o1_fax': '0330-88-1591',
      'o1_mail': 'oomori@exa.com',
      'o1_url': 'http://www.example.com',
      'valid_o1_url': 'http://www.example.com',
      'o2_zipcode': '100-2525',
      'o2_address1': '東京都品川区西大井1-1-2',
      'o2_address2': '八木ビル5F',
      'o2_tel1': '0330-88-1590',
      'o2_naisen1': '00331',
      'o2_tel2': '0330-88-1595',
      'o2_naisen2': '00331',
      'o2_mobile': '080-1212-3434',
      'o2_fax': '0330-88-1591',
      'o2_mail': 'oomori@exa.com',
      'o2_url': 'http://www.example.com',
      'valid_o2_url': 'http://www.example.com',
      'person': {
        'openflag': '1'
      },
      'isFavorite': '1',
      'tags': [
        {
          'id': 1,
          'name': 'サンプルタグ',
          'openflag': '1',
          'seqno': 1,
          'color_rgb': '#ffecb3'
        }
      ],
      'is_latest': '1',
      'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t',
      'exchanger': {
        'sid_user': 1,
        'full_name': '山田 太郎'
      },
      'full_name': '大森 圭介',
      'full_kana': 'おおもり けいすけ',
      'formatted_exdate': '2018/01/01',
      'updated': '2018/01/02 33:44:55',
      'upduser_full_name': '大森 圭介',
      'isExchanged': '1',
      'editablePublic': '1',
      'isProxing': '0',
      'imageError': '0'
    }
  })

  // // 既存人物の名刺情報を取得
  // // (TODO) そのうち/persons/{person_id}/bcards/{bcard_id}に統合されるようなので、その時に対応する
  // mockAxios.onGet(new RegExp(`/persons/\\d+/latestbcard`)).reply(200, {
  //   'success': true,
  //   'data': {
  //     'id': 1,
  //     'sid_person': 1,
  //     'last_name': '大森',
  //     'first_name': '圭介',
  //     'last_kana': 'オオモリ',
  //     'first_kana': 'ケイスケ',
  //     'corporate_name': '株式会社RRRコンピューターサービス',
  //     'corporate_kana': 'あーるあーるあーる',
  //     'company_name': 'あーるあーるあーる',
  //     'company_kana': 'あーるあーるあーる',
  //     'dept': '公共情報事業本部',
  //     'post': '主任心得',
  //     'dept_post': '技術課＋部長',
  //     'o1_office_name': '横浜事業所',
  //     'o1_zipcode': '100-2525',
  //     'o1_address1': '東京都品川区西大井1-1-2',
  //     'o1_address2': '八木ビル5F',
  //     'o1_tel1': '0330-88-1590',
  //     'o1_naisen1': '00331',
  //     'o1_tel2': '0330-88-1595',
  //     'o1_naisen2': '00331',
  //     'o1_mobile': '080-1212-3434',
  //     'o1_fax': '0330-88-1591',
  //     'o1_mail': 'oomori@exa.com',
  //     'o1_url': 'http://www.example.com',
  //     'o2_office_name': '横浜事業所',
  //     'o2_zipcode': '100-2525',
  //     'o2_address1': '東京都品川区西大井1-1-2',
  //     'o2_address2': '八木ビル5F',
  //     'o2_tel1': '0330-88-1590',
  //     'o2_naisen1': '00331',
  //     'o2_tel2': '0330-88-1595',
  //     'o2_naisen2': '00331',
  //     'o2_mobile': '080-1212-3434',
  //     'o2_fax': '0330-88-1591',
  //     'o2_mail': 'oomori@exa.com',
  //     'o2_url': 'http://www.example.com',
  //     'image_id': '01k20094169p8y3t',
  //     'person': {
  //       'id': 1,
  //       'openflag': '1',
  //       'twitter_id': 'twitter_example',
  //       'blog_url': 'http://blog.example.com',
  //       'memo': '・一部上場を目指し、様々な事業を取りまとめている方です。\n・趣味：毎週末、ゴルフの練習に行くこと。'
  //     },
  //     'images': [
  //       {
  //         'sid_attach': '01k20094169p8y3t',
  //         'id': 1,
  //         'name': '裏面.jpeg',
  //         'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t'
  //       }
  //     ],
  //     'tags': [
  //       {
  //         'id': 1,
  //         'name': 'サンプルタグ',
  //         'color_rgb': '#ffecb3'
  //       }
  //     ],
  //     'pv_person': {
  //       'sid_person': 1,
  //       'memo': '',
  //       'keyword01': 'サンプルキーワード',
  //       'keyword02': 'サンプルキーワード',
  //       'keyword03': 'サンプルキーワード',
  //       'keyword04': 'サンプルキーワード',
  //       'keyword05': 'サンプルキーワード',
  //       'keyword06': 'サンプルキーワード',
  //       'keyword07': 'サンプルキーワード',
  //       'keyword08': 'サンプルキーワード',
  //       'keyword09': 'サンプルキーワード',
  //       'keyword10': 'サンプルキーワード'
  //     }
  //   }
  // })

  // latest
  mockAxios.onGet(new RegExp(`/persons/\\d+/bcards/0`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'sid_person': 1,
      'last_name': '大森',
      'first_name': '圭介',
      'last_kana': 'オオモリ',
      'first_kana': 'ケイスケ',
      'corporate_name': '株式会社RRRコンピューターサービス',
      'corporate_kana': 'あーるあーるあーる',
      'company_name': 'RRRカンパニー',
      'company_kana': 'あーるあーるあーるかんぱにー',
      'dept': '公共情報事業本部',
      'post': '主任心得',
      'dept_post': '技術課＋部長',
      'o1_office_name': '横浜事業所',
      'o1_zipcode': '100-2525',
      'o1_address1': '東京都品川区西大井1-1-2',
      'o1_address2': '八木ビル5F',
      'o1_tel1': '0330-88-1590',
      'o1_naisen1': '00331',
      'o1_tel2': '0330-88-1595',
      'o1_naisen2': '00331',
      'o1_mobile': '080-1212-3434',
      'o1_fax': '0330-88-1591',
      'o1_mail': 'oomori@exa.com',
      'o1_url': 'http://www.example.com',
      'o2_office_name': '横浜事業所',
      'o2_zipcode': '100-2525',
      'o2_address1': '東京都品川区西大井1-1-2',
      'o2_address2': '八木ビル5F',
      'o2_tel1': '0330-88-1590',
      'o2_naisen1': '00331',
      'o2_tel2': '0330-88-1595',
      'o2_naisen2': '00331',
      'o2_mobile': '080-1212-3434',
      'o2_fax': '0330-88-1591',
      'o2_mail': 'oomori@exa.com',
      'o2_url': 'http://www.example.com',
      'image_id': '01k20094169p8y3t',
      'exchanges': [
        {
          'id': 1,
          'sid_user': 10,
          'full_name': '山田 太郎', // V2で追加
          'exchange_date': '20180101',
          'ex_location': '',
          'ex_location_detail': '',
          'ex_trigger': '',
          'ex_trigger_detail': '',
          'in_introducer': 1,
          'out_introducer': 1,
          'age': 10,
          'feature': '',
          'comment': '',
          'formatted_exdate': '2018/01/01'
        }
      ],
      'images': [
        {
          'sid_attach': '01k20094169p8y3t',
          'id': 1,
          'name': '裏面.jpeg',
          'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t'
        }
      ],
      'is_latest': '1',
      'is_exchanged': '1',
      'is_jusged': '0',
      'full_name': '大森 圭介',
      'full_kana': 'おおもり けいすけ',
      'formatted_exdate': '2018/01/01',
      'valid_o1_url': 'http://www.example.com',
      'valid_o2_url': 'http://www.example.com'
    }
  })

  mockAxios.onGet(new RegExp(`/persons/\\d+/bcards/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'sid_person': 1,
      'last_name': '大森',
      'first_name': '圭介',
      'last_kana': 'オオモリ',
      'first_kana': 'ケイスケ',
      'corporate_name': '株式会社RRRコンピューターサービス',
      'corporate_kana': 'あーるあーるあーる',
      'company_name': 'RRRカンパニー',
      'company_kana': 'あーるあーるあーるかんぱにー',
      'dept': '公共情報事業本部',
      'post': '主任心得',
      'dept_post': '技術課＋部長',
      'o1_office_name': '横浜事業所',
      'o1_zipcode': '100-2525',
      'o1_address1': '東京都品川区西大井1-1-2',
      'o1_address2': '八木ビル5F',
      'o1_tel1': '0330-88-1590',
      'o1_naisen1': '00331',
      'o1_tel2': '0330-88-1595',
      'o1_naisen2': '00331',
      'o1_mobile': '080-1212-3434',
      'o1_fax': '0330-88-1591',
      'o1_mail': 'oomori@exa.com',
      'o1_url': 'http://www.example.com',
      'o2_office_name': '横浜事業所',
      'o2_zipcode': '100-2525',
      'o2_address1': '東京都品川区西大井1-1-2',
      'o2_address2': '八木ビル5F',
      'o2_tel1': '0330-88-1590',
      'o2_naisen1': '00331',
      'o2_tel2': '0330-88-1595',
      'o2_naisen2': '00331',
      'o2_mobile': '080-1212-3434',
      'o2_fax': '0330-88-1591',
      'o2_mail': 'oomori@exa.com',
      'o2_url': 'http://www.example.com',
      'image_id': '01k20094169p8y3t',
      'exchanges': [
        {
          'id': 1,
          'sid_user': 10,
          'full_name': '山田 太郎', // V2で追加
          'exchange_date': '20180101',
          'ex_location': '',
          'ex_location_detail': '',
          'ex_trigger': '',
          'ex_trigger_detail': '',
          'in_introducer': 1,
          'out_introducer': 1,
          'age': 10,
          'feature': '',
          'comment': '',
          'formatted_exdate': '2018/01/01'
        }
      ],
      'images': [
        {
          'sid_attach': '01k20094169p8y3t',
          'id': 1,
          'name': '裏面.jpeg',
          'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t'
        }
      ],
      'is_latest': '0',
      'full_name': '大森 圭介',
      'full_kana': 'おおもり けいすけ',
      'formatted_exdate': '2018/01/01',
      'valid_o1_url': 'http://www.example.com',
      'valid_o2_url': 'http://www.example.com'
    }
  })

  // 同一人物検索
  mockAxios.onPost(`/persons/duplicates`).reply(200, {
    'success': true,
    'data': {
      'hitboth': [
        {
          'id': 1,
          'full_name': '大森 圭介',
          'corporate_name': '株式会社RRRコンピューターサービス',
          'dept': '公共情報事業本部',
          'post': '主任心得',
          'image_id': '01k20094169p8y3t',
          'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
          'formatted_exdate': '2018/01/01',
          'openflag': '1'
        }
      ],
      'hitname': [
        {
          'id': 2,
          'full_name': '大森 けいすけ',
          'corporate_name': '株式会社RRRコンピューターサービス',
          'dept': '公共情報事業本部',
          'post': '主任心得',
          'image_id': '01k20094169p8y3t',
          'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
          'formatted_exdate': '2018/05/01',
          'openflag': '1'
        }
      ]
    }
  })

  // 編集画面用に既存人物の名刺情報を取得する
  mockAxios.onGet(new RegExp(`/persons/\\d+$`)).reply(200, {
    'success': true,
    'data': {
      'id': 13,
      'sid_person': 1,
      'last_name': '人物①：自分が「名刺①(最新)」の交換者の場合',
      'first_name': '',
      'last_kana': '人物①：自分が「名刺①(最新)」の交換者の場合',
      'first_kana': '',
      'corporate_name': '',
      'corporate_kana': '',
      'company_name': '',
      'company_kana': '',
      'dept': '',
      'post': '',
      'dept_post': '',
      'o1_office_name': '',
      'o1_zipcode': '',
      'o1_address1': '',
      'o1_address2': '',
      'o1_tel1': '',
      'o1_naisen1': '',
      'o1_tel2': '',
      'o1_naisen2': '',
      'o1_mobile': '',
      'o1_fax': '',
      'o1_mail': '',
      'o1_url': '',
      'o2_office_name': '',
      'o2_zipcode': '',
      'o2_address1': '',
      'o2_address2': '',
      'o2_tel1': '',
      'o2_naisen1': '',
      'o2_tel2': '',
      'o2_naisen2': '',
      'o2_mobile': '',
      'o2_fax': '',
      'o2_mail': '',
      'o2_url': '',
      'image_id': null,
      'full_name': '人物①：自分が「名刺①(最新)」の交換者の場合',
      'full_kana': '人物①：自分が「名刺①(最新)」の交換者の場合',
      'person': {
        'id': 1,
        'openflag': '1',
        'twitter_id': '',
        'blog_url': '',
        'memo': ''
      },
      'images': [],
      'exchanges': [],
      'pv_person': [],
      'tags': []
    }
  })

  // 更新
  mockAxios.onPut(new RegExp(`/persons/\\d+$`)).reply(201, {
    'success': true,
    'data': []
  })

  // ソーシャルサイトの内容を取得します。
  mockAxios.onGet(new RegExp(`/persons/\\d+/social`)).reply(200, {
    'success': true,
    'data': {
      'twitter_id': 'twitter_example',
      'twitter_url': 'https://twitter.com/twitter_example',
      'blog_url': 'http://blog.example.com',
      'valid_blog_url': 'http://blog.example.com'
    }
  })

  // 共有メモの内容を取得します。
  mockAxios.onGet(new RegExp(`/persons/\\d+/memo`)).reply(200, {
    'success': true,
    'data': {
      'memo': '・一部上場を目指し、様々な事業を取りまとめている方です。'
    }
  })

  // 個人メモの内容を取得します。
  mockAxios.onGet(new RegExp(`/persons/\\d+/pvmemo`)).reply(200, {
    'success': true,
    'data': {
      'memo': '・趣味：毎週末、ゴルフの練習に行くこと。'
    }
  })

  // 個人メモの内容を更新します。
  mockAxios.onPut(new RegExp(`/persons/\\d+/pvmemo`)).reply(201, {
    'success': true,
    'data': []
  })

  // 検索キーワードの内容を取得します。
  mockAxios.onGet(new RegExp(`/persons/\\d+/pvkeywords`)).reply(200, {
    'success': true,
    'data': {
      'keyword01': 'サンプルキーワード01',
      'keyword02': 'サンプルキーワード02',
      'keyword03': 'サンプルキーワード03',
      'keyword04': 'サンプルキーワード04',
      'keyword05': 'サンプルキーワード05',
      'keyword06': 'サンプルキーワード06',
      'keyword07': 'サンプルキーワード07',
      'keyword08': 'サンプルキーワード08',
      'keyword09': 'サンプルキーワード09',
      'keyword10': 'サンプルキーワード10'
    }
  })

  // 検索キーワードの内容を更新します。
  mockAxios.onPut(new RegExp(`/persons/\\d+/pvkeywords`)).reply(201, {
    'success': true,
    'data': []
  })

  // 交換者一覧を取得します。
  mockAxios.onGet(new RegExp(`/persons/\\d+/exchangers`)).reply(200, {
    'success': true,
    'data': [
      {
        'id': 11,
        'post': '部長',
        'dept': '技術開発事業部',
        'exchanger_full_name': '山田 太郎',
        'formatted_first_date': '2018/01/01',
        'formatted_last_date': '2018/01/01',
        'user_state': '0'
      },
      {
        'id': 40,
        'post': '主任',
        'dept': '技術開発事業部',
        'exchanger_full_name': '中田 次郎',
        'formatted_first_date': '2018/01/01',
        'formatted_last_date': '2018/01/01',
        'user_state': '0'
      },
      {
        'id': 41,
        'post': '係長',
        'dept': '技術開発事業部',
        'exchanger_full_name': '下田 三郎',
        'formatted_first_date': '2018/01/01',
        'formatted_last_date': '2017/01/01',
        'user_state': '0'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  // 兼務一覧
  mockAxios.onGet(new RegExp(`/persons/\\d+/concposts`)).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'openflag': '1',
        'full_name': '大森 圭介',
        'corporate_name': '株式会社RRRコンピューターサービス',
        'dept': '公共情報事業本部',
        'post': '主任心得',
        'bcards': [
          {
            'id': 101,
            'sid_corporate': 1,
            'sid_person': 11,
            'full_name': '大森 圭介',
            'full_kana': 'おおもり けいすけ',
            'last_kana': 'オオモリ',
            'first_kana': 'ケイスケ',
            'corporate_name': 'さわやか工房',
            'corporate_kana': 'あーるあーるあーる',
            'dept': '公共情報事業本部',
            'post': '主任心得',
            'image_id': '01k20094169p8y3t',
            'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
            'exchange_date': '20180101',
            'formatted_exdate': '2018/01/01'
          },
          {
            'id': 102,
            'sid_corporate': 1,
            'sid_person': 12,
            'full_name': '大森 圭介',
            'full_kana': 'おおもり けいすけ',
            'last_kana': 'オオモリ',
            'first_kana': 'ケイスケ',
            'corporate_name': 'インターコンチネンタル',
            'corporate_kana': 'あーるあーるあーる',
            'dept': '公共情報事業本部',
            'post': '主任心得',
            'image_id': '01k20094169p8y3t',
            'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
            'exchange_date': '20180101',
            'formatted_exdate': '2018/01/01'
          }
        ]
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/personRepositoryMock.js